/**
 * Every daily challenge that has had its day, newest first.
 *
 * The front page carries one fight; this is the rest of them. Each row says
 * the same things the card did on the day — what it was called, the line about
 * it, the board, what each side was worth — because somebody arriving here is
 * deciding whether to play one, and that is the same decision.
 *
 * A backlog challenge is playable and does not score. Scoring a fight after
 * its day would rank a player who took their time against players who had one
 * evening, and there is no honest way to compare those. The row says so rather
 * than leaving it to be found out.
 *
 * Nothing here calls the API. This page is bundled like the front page is, and
 * a list of past fights has no reason to go dark when the control plane does.
 */

import { footer } from "../chrome";
import { el } from "../dom";
import { archive, challengeCard, utcDay } from "./daily";

export function dailyArchiveScreen(): Node[] {
  const today = utcDay();
  const past = archive(today);

  return [
    // The class is the page's width: styles.css gives a body holding it the
    // room the front page gives the same card. See the --shell rules.
    el("div", { className: "stack daily-archive" }, [
      el("h1", { textContent: "Daily challenges" }),
      el("p", {
        className: "hint",
        textContent:
          past.length === 0
            ? "Nothing has been set yet."
            : "One fight a day, the same for everyone. Today's is scored; the rest are here to play.",
      }),
      ...past.map((challenge) => challengeCard(challenge, today)),
    ]),
    footer(),
  ];
}
